/* <rr-popup> — abre el popup de captación (sections/email-popup.liquid) cuando
   toca: a los N segundos o al pasar un X % de la página, lo que llegue antes.
   No sale a quien ya se suscribió (aquí o en otro formulario de la web) ni a
   quien llega desde un email, y nunca encima del carrito, del menú, de otro
   diálogo ni del aviso de cookies. Si se cierra, no vuelve hasta pasados N
   días (localStorage; sin él, sale en cada visita y ya está). Quien llega desde
   un anuncio de suscripción (?rr_join=1) lo ve aunque lo cerrara otro día, pero
   solo después de haber visto piezas (pieces()).
   Tras enviar, Shopify recarga con ?customer_posted=true#rr-popup-form: el
   ancla dice que el envío fue de ESTE formulario y el popup se abre solo con
   el "mira tu email" o con el error. En el editor se abre al seleccionar la
   sección, sin modal para no bloquear el editor.
   La cuña ([data-rr-popup-tab], 24 oct 2026): sale cuando el popup se ha cerrado sin
   suscribirse (en esa visita o en otra), lo vuelve a abrir al tocarla y desaparece al
   suscribirse; su ✕ la esconde 30 días (tabOff en el mismo localStorage). */
(() => {
  if (customElements.get('rr-popup')) return;

  const KEY = 'rr-popup';
  const load = () => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || {};
    } catch {
      return {};
    }
  };
  const save = (v) => {
    try {
      localStorage.setItem(KEY, JSON.stringify(v));
    } catch {}
  };
  // medición (rr_popup, docs/plan-de-medicion.md §4.10): sale (y por qué), se cierra o se envía
  const rr = (n, p) => window.rrTrack && window.rrTrack(n, p);

  class RRPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      this.ac = new AbortController();
      const opts = { signal: this.ac.signal };

      this.querySelector('[data-rr-popup-close]').addEventListener('click', () => this.dialog.close(), opts);
      // clic en el fondo oscuro, fuera de la caja: cerrar
      this.dialog.addEventListener('click', (e) => e.target === this.dialog && this.dialog.close(), opts);
      // tras suscribirse, el código general sale en pantalla: copiarlo de un toque
      const copy = this.querySelector('[data-rr-copy]');
      if (copy) {
        copy.addEventListener(
          'click',
          () => {
            const done = () => {
              copy.textContent = copy.dataset.done;
              rr('rr_popup', { action: 'copy_code' });
            };
            if (navigator.clipboard) navigator.clipboard.writeText(copy.dataset.rrCopy).then(done, () => {});
          },
          opts,
        );
      }

      if (window.Shopify && window.Shopify.designMode) {
        const mine = (e) => e.detail && e.detail.sectionId === this.dataset.sectionId;
        const open = (e) => mine(e) && !this.dialog.open && this.dialog.show();
        document.addEventListener('shopify:section:select', open, opts);
        document.addEventListener('shopify:section:load', open, opts);
        document.addEventListener('shopify:section:deselect', (e) => mine(e) && this.dialog.close(), opts);
        return;
      }

      const q = new URLSearchParams(location.search);
      if (q.get('customer_posted') === 'true' || q.has('_kx') || q.get('utm_medium') === 'email') save({ done: 1 });
      this.dialog.addEventListener(
        'close',
        () => {
          if (!load().done) save({ ...load(), closed: Date.now() });
          this.tab();
          if (this.openedAt) {
            rr('rr_popup', { action: 'close', open_ms: Date.now() - this.openedAt });
            this.openedAt = 0;
          }
        },
        opts,
      );
      const form = this.querySelector('form');
      if (form) form.addEventListener('submit', () => rr('rr_popup', { action: 'submit' }), opts);
      this.tabEl = this.querySelector('[data-rr-popup-tab]');
      if (this.tabEl) {
        this.tabEl.querySelector('[data-rr-popup-tab-open]').addEventListener(
          'click',
          () => {
            this.tabEl.hidden = true;
            this.dialog.showModal();
            this.opened('tab');
          },
          opts,
        );
        this.tabEl.querySelector('[data-rr-popup-tab-x]').addEventListener(
          'click',
          () => {
            save({ ...load(), tabOff: Date.now() });
            this.tabEl.hidden = true;
          },
          opts,
        );
        this.tab();
      }

      const state = this.querySelector('[data-rr-popup-state]');
      if (state && location.hash === '#rr-popup-form') {
        this.show('result');
        return;
      }

      const s = load();
      if (s.done) return;
      // Anuncios de suscripción (21 oct 2026): ?rr_join=1 marca toda la visita
      // (sessionStorage rr-join) y el popup sale aunque se hubiera cerrado en otra
      // visita, pero nunca nada más llegar. Cesar: "un popup sin mostrar nada antes es
      // suscribirse a ciegas". Espera a que se hayan visto piezas (pieces()). Si se
      // cierra, no vuelve en esta visita. El aviso de cookies propio no lo frena.
      let join = q.get('rr_join') === '1' ? 'on' : null;
      try {
        const kept = sessionStorage.getItem('rr-join');
        if (kept === 'closed') join = null;
        else if (join) sessionStorage.setItem('rr-join', 'on');
        else join = kept;
      } catch {}
      if (join === 'on') {
        this.forced = true;
        this.dialog.addEventListener(
          'close',
          () => {
            try {
              sessionStorage.setItem('rr-join', 'closed');
            } catch {}
          },
          opts,
        );
        this.pieces();
        return;
      }
      if (s.closed && Date.now() - s.closed < Number(this.dataset.days || 14) * 864e5) return;

      const delay = Number(this.dataset.delay || 0);
      const depth = Number(this.dataset.scroll || 0);
      const root = document.documentElement;
      const onScroll = () => {
        const max = root.scrollHeight - window.innerHeight;
        if (max > 0 && (window.scrollY / max) * 100 >= depth) fire('scroll');
      };
      const fire = (trigger) => {
        clearTimeout(this.timer);
        window.removeEventListener('scroll', onScroll);
        this.show(trigger);
      };
      if (delay > 0) this.timer = setTimeout(() => fire('time'), delay * 1000);
      if (depth > 0) window.addEventListener('scroll', onScroll, { passive: true, signal: this.ac.signal });
    }

    disconnectedCallback() {
      if (this.ac) this.ac.abort();
      if (this.io) this.io.disconnect();
      clearTimeout(this.timer);
      clearTimeout(this.late);
    }

    // Visita desde el anuncio: cuenta las tarjetas de pieza (.rr-card) que han estado al
    // menos medio dentro de la pantalla. Con 4 vistas, o en una ficha, se abre a partir de
    // los 8 s en la página. Si no, a los 25 s, para que quien pulsó el anuncio y no baja
    // tenga igualmente su 10 %.
    pieces() {
      const seen = new Set();
      let ready = false;
      const fire = () => {
        if (this.fired) return;
        this.fired = true;
        clearTimeout(this.timer);
        clearTimeout(this.late);
        if (this.io) this.io.disconnect();
        this.show('join');
      };
      const check = () => ready && (seen.size >= 4 || this.dataset.template === 'product') && fire();
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(
          (entries) => {
            for (const e of entries) {
              if (!e.isIntersecting) continue;
              seen.add(e.target);
              this.io.unobserve(e.target);
            }
            check();
          },
          { threshold: 0.5 },
        );
        document.querySelectorAll('.rr-card').forEach((card) => this.io.observe(card));
      }
      this.timer = setTimeout(() => {
        ready = true;
        check();
      }, 8000);
      this.late = setTimeout(fire, 25000);
    }

    // La cuña: solo si el popup se cerró alguna vez sin suscribirse y su ✕ no se pulsó en
    // los últimos 30 días; nunca con el popup abierto.
    tab() {
      if (!this.tabEl) return;
      const s = load();
      const off = s.tabOff && Date.now() - s.tabOff < 30 * 864e5;
      this.tabEl.hidden = !!(s.done || !s.closed || off || this.dialog.open);
    }

    // trigger: time, scroll o join (anuncio de suscripción); result = vuelve de enviarlo, no cuenta
    show(trigger) {
      if (this.dialog.open) return;
      if (this.tabEl) this.tabEl.hidden = true;
      if (this.busy()) {
        this.timer = setTimeout(() => this.show(trigger), 4000);
        return;
      }
      this.dialog.showModal();
      if (trigger !== 'result') this.opened(trigger);
    }

    opened(trigger) {
      this.openedAt = Date.now();
      rr('rr_popup', { action: 'shown', trigger });
    }

    // Carrito, menú u otro diálogo abiertos, o un aviso de cookies a la vista (el
    // de Shopify o, desde el 21 oct 2026, el propio #rr-cookies): se reintenta en
    // un rato. El popup es modal y dejaría el aviso bloqueado detrás.
    busy() {
      const avisos = this.forced ? '#shopify-pc__banner, #shopify-pc__prefs' : '#shopify-pc__banner, #shopify-pc__prefs, #rr-cookies:not([hidden])';
      const privacy = document.querySelector(avisos);
      if (privacy && privacy.getClientRects().length) return true;
      return !!document.querySelector('rr-cart-drawer.is-open, [data-rr-burger][open], dialog[open]');
    }
  }

  customElements.define('rr-popup', RRPopup);
})();
